import type { Board } from "../board";
import type { Direction } from "../direction";
import { directionDelta } from "../direction";
import type { Player } from "../player";
import { CryoShot } from "../projectiles/cryoShot";
import { Sound } from "../things/sounds/sound";
import { SoundId } from "../things/sounds/soundId";
import { ParticleType } from "../particleType";
import { Weapon } from "../weapon";

export class CryoGun extends Weapon {
	static key = "CryoGun";
	constructor(owner: Player) {
		super(owner, 0, true);
	}

	override getMuzzleFlashType(): ParticleType {
		return ParticleType.MUZZLE_FLASH_ICE;
	}

	fire(direction: Direction, board: Board): void {
		board.addNonPhysicalThing(new Sound(SoundId.SHOT_SOLIDIFIER));
		const spawnPos = this.owner.xy.add(directionDelta(direction));
		const shot = new CryoShot(spawnPos, direction);
		this.shotProjectile(board, shot);
	}

	static deserialize(data: any, owner: Player): CryoGun {
		const gun = new CryoGun(owner);
		gun.ammo = data.ammo;
		return gun;
	}
}
